import { useState } from "react";
import { Card } from "@/components/ui/Card";
import useDocumentTitle from "@/hooks/UseDocumentTitle";
import { KanbanBoard } from "./component/TaskBoard";
import TasksManagementTable from "../tasks/component/table";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/ToggleGroup";
import { ViewIcon, ListIcon } from "lucide-react";
import { TicketStatus, useGetAllTaskCountQuery } from "@/services/LiveQueueService";
import { getStatusColor } from "@/utils/Helper";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/Tabs";

export default function TaskBoardView() {
    const {data} =useGetAllTaskCountQuery();
  
  useDocumentTitle("Task Management");
  const [viewMode, setViewMode] = useState<"kanban" | "list">("kanban");

  return (
    <div className="w-full p-2">
      <Card className="pt-3">
        <div className="flex justify-between items-center px-4 ">
          <div className="flex justify-start px-4">
            <Tabs
              defaultValue="kanban"
              value={viewMode}
              onValueChange={(value) =>
                value && setViewMode(value as "kanban" | "list")
              }
            >
              <TabsList>
                <TabsTrigger value="kanban" variant={"primary"}>
                  <ViewIcon className="h-4 w-4 mr-2" />
                  Kanban
                </TabsTrigger>
                <TabsTrigger value="list" variant={"primary"}>
                  <ListIcon className="h-4 w-4 mr-2" />
                  List
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
          <div className="bg-white rounded-md border border-gray-200">
            <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-2 flex-grow w-full">
                {[
                  {
                    status: "ARCHIVED",
                    label: "Pending",
                    value: data?.tasks.todo ?? 0,
                  },
                  {
                    status: "CHECKED_IN",
                    label: "In Progress",
                    value: data?.tasks.in_progress ?? 0,
                  },
                  {
                    status: "COMPLETED",
                    label: "Complete",
                    value: data?.tasks.completed ?? 0,
                  },
                  {
                    status: "CANCELLED",
                    label: "Hold",
                    value: data?.tasks.hold ?? 0,
                  },
                  {
                    status: "Archived",
                    label: "Archived",
                    value: data?.tasks.archived ?? 0,
                  },
                ].map((item) => (
                  <button
                    key={item.status}
                    className={`${getStatusColor(item.status as TicketStatus)} text-white rounded-md p-2 flex flex-col items-center justify-center w-full`}
                  >
                    <div className="text-2xl font-bold">{item.value}</div>
                    <div className="text-xs">{item.label}</div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {viewMode === "kanban" ? <KanbanBoard /> : <TasksManagementTable />}
      </Card>
    </div>
  );
}